export const DISPATCH_COUNT = "DISPATCH_COUNT";
export const DISPATCHES = "DISPATCHES";
export const DISPATCHES_NEXT = "DISPATCHES_NEXT";
export const BUSY_DISPATCH = "BUSY_DISPATCH";
export const ADD_DISPATCH_BUSY = "ADD_DISPATCH_BUSY";
export const SELECTED_DISPATCH = "SELECTED_DISPATCH";
export const SELECTED_DISPATCH_SHIPPER = "SELECTED_DISPATCH_SHIPPER";
export const DISPATCH_SMS = "DISPATCH_SMS";
export const DISPATCH_UPDATES = "DISPATCH_UPDATES";
